module.exports = __webpack_public_path__ + "assets/img/食品添加.a835293f.png";